import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { useBasicAuth } from '../../../shared/components/auth/withBasicAuth';
import {environment} from '../../../containers/environment';

class NotFound404 extends PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({ changeLanguage: PropTypes.func }).isRequired,
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super();

    let lng = localStorage.getItem(environment.LANGUAGE);
    if(lng !== null && lng !== undefined){
      props.i18n.changeLanguage(lng);
    }

    useBasicAuth.clearIntervals(true);
  }

  render() {
    const { t } = this.props;
    
    return (
      <div className="not-found">
        <div style={{marginTop: "0px", marginLeft: "auto", marginRight: "auto"}}>
          {/* <img className="not-found__image" src={Image404} alt="404" /> */}
          <h3>
            {t('forms.error404')}
          </h3>
          <Link className="btn btn-primary" to="/home">{t('forms.home')}</Link>
        </div>
      </div>            
    );
  }
}

export default reduxForm({
  form: 'login_form_404', // a unique identifier for this form
})(withTranslation('common')(NotFound404));